"use client"
import { 
    Activity, 
    Building2, 
    Users, 
    Store,
    HelpCircle as HelpIcon,
    ChevronUp,
    LayoutDashboard,
    MessageSquare,
    UserCircle
} from "lucide-react";
import { useOnborda } from "onborda";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSession } from "next-auth/react";

export default function FloatingOnbordaMenu() {
    const { startOnborda } = useOnborda();
    const { data: session } = useSession();
    const userType = session?.user?.user_type || session?.user?.type || session?.user?.role;

    const tours = [
        { 
            id: "welcome", 
            label: "Bienvenue", 
            icon: LayoutDashboard, 
            tourName: "welcome_tour",
            role: "all"
        },
        { 
            id: "activities", 
            label: "Activités", 
            icon: Activity, 
            tourName: "activities_tour",
            role: "all"
        },
        { 
            id: "management", 
            label: "Gestion Pro", 
            icon: Building2, 
            tourName: "management_tour",
            role: "pro"
        },
        { 
            id: "social", 
            label: "Social & Communication", 
            icon: Users, 
            tourName: "social_tour",
            role: "all"
        },
        { 
            id: "myspace", 
            label: "Mon Espace", 
            icon: UserCircle, 
            tourName: "my_space_tour",
            role: "all"
        }
    ];

    // Filtrer les tours selon le rôle (pro = 2 généralement dans ce projet d'après DashboardLayout)
    const filteredTours = tours.filter(tour => {
        if (tour.role === "all") return true;
        if (tour.role === "pro") return userType === 2;
        return false;
    });

    return (
        <div className="fixed bottom-6 right-6 z-50">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button 
                        size="icon" 
                        className="h-14 w-14 rounded-full shadow-lg bg-cwfLanding hover:bg-cwfLanding/90 text-white"
                    >
                        <HelpIcon className="h-7 w-7" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="mb-2 w-56 bg-white border-none shadow-xl rounded-xl p-2">
                    <div className="px-2 py-1.5 text-sm font-semibold text-gray-500">Besoin d'aide ?</div>
                    {filteredTours.map((tour) => (
                        <DropdownMenuItem 
                            key={tour.id}
                            className="flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors group"
                            onClick={() => startOnborda(tour.tourName)}
                        >
                            <div className="p-2 bg-gray-50 rounded-lg group-hover:bg-cwfLanding/10 transition-colors">
                                <tour.icon className="h-4 w-4 text-gray-600 group-hover:text-cwfLanding" />
                            </div>
                            <span className="font-medium text-gray-700 group-hover:text-black">{tour.label}</span>
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
